import { render, staticRenderFns } from "./ReportColumnsForm.vue?vue&type=template&id=5fef9176&scoped=true&"
import script from "./ReportColumnsForm.vue?vue&type=script&lang=js&"
export * from "./ReportColumnsForm.vue?vue&type=script&lang=js&"
import style0 from "./ReportColumnsForm.vue?vue&type=style&index=0&id=5fef9176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fef9176",
  null
  
)

export default component.exports